import { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { doc, setDoc, deleteDoc } from "firebase/firestore";
import { db } from "../firebase/firebase";
import { collection, onSnapshot } from "firebase/firestore";


export default function CalendarioNutricionista({ turnos, pacientes }) {
  const [fechaSeleccionada, setFechaSeleccionada] = useState(null);
  const [turnosDia, setTurnosDia] = useState([]);
  const [diasBloqueados, setDiasBloqueados] = useState([]);
  const [horariosBloqueados, setHorariosBloqueados] = useState({});
  const horarios = Array.from({ length: 13 }, (_, i) => i + 8);




  useEffect(() => {
    // 🔴 DÍAS BLOQUEADOS
    const unsubDias = onSnapshot(collection(db, "bloqueosDias"), (snapshot) => {
      const dias = snapshot.docs.map(doc => doc.id);
      setDiasBloqueados(dias);
    });
  
    // 🔴 HORARIOS BLOQUEADOS
    const unsubHorarios = onSnapshot(collection(db, "bloqueosHorarios"), (snapshot) => {
      const data = {};
  
      snapshot.docs.forEach(doc => {
        const { fecha, hora } = doc.data();
  
        if (!data[fecha]) data[fecha] = [];
        data[fecha].push(hora);
      });
  
      setHorariosBloqueados(data);
    });
  
    return () => {
      unsubDias();
      unsubHorarios();
    };
  }, []);

  // Actualiza los turnos del día al cambiar la fecha
  useEffect(() => {
    if (fechaSeleccionada) {
      console.log("Fecha seleccionada:", fechaSeleccionada);
  
      const dateStr = formatearFecha(fechaSeleccionada);
  
      const filtrados = turnos.filter(t => {
        if (!t.fechaHora) return false;
  
        const fechaTurno = t.fechaHora.toDate();
        return formatearFecha(fechaTurno) === dateStr;
      });
  
      console.log("Turnos filtrados:", filtrados);
  
      setTurnosDia(filtrados);
    }
  }, [fechaSeleccionada, turnos]);

  // Bloquear o desbloquear un horario
  const toggleBloquearHorario = async (fecha, hora) => {
    const dateStr = fecha.toISOString().split("T")[0];
    const id = `${dateStr}_${hora}`;
  
    const ref = doc(db, "bloqueosHorarios", id);
  
    const bloqueado = horariosBloqueados[dateStr]?.includes(hora);
  
    if (bloqueado) {
      await deleteDoc(ref);
    } else {
      await setDoc(ref, {
        fecha: dateStr,
        hora: hora,
      });
    }
  };

  const formatearFecha = (fecha) => {
    return fecha.toISOString().split("T")[0];
  };

  // Bloquear o desbloquear un día completo
 

const toggleBloquearDia = async (fecha) => {
  const dateStr = fecha.toISOString().split("T")[0];
  const ref = doc(db, "bloqueosDias", dateStr);

  if (diasBloqueados.includes(dateStr)) {
    await deleteDoc(ref); // desbloquear
  } else {
    await setDoc(ref, { fecha: dateStr }); // bloquear
  }
};

  return (
    <div
    style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      padding: "20px",
      gap: "20px"
    }}
  >
      {/* Calendario */}
     
      <DatePicker
  selected={fechaSeleccionada}
  onChange={setFechaSeleccionada}
  inline
  minDate={new Date()}

  /* 🔥 BLOQUEAR DOMINGOS */
  filterDate={(date) => date.getDay() !== 0}

  /* 🔥 FORMATO DÍAS */
  formatWeekDay={(nameOfDay) => {
    const dias = {
      Sunday: "D",
      Monday: "L",
      Tuesday: "M",
      Wednesday: "Mi",
      Thursday: "J",
      Friday: "V",
      Saturday: "S",
    };
    return dias[nameOfDay];
  }}

  /* 🔥 COLORES PERSONALIZADOS */
  dayClassName={(date) => {
    const dateStr = date.toISOString().split("T")[0];

    if (date.getDay() === 0) return "dia-domingo";

    if (diasBloqueados.includes(dateStr)) return "dia-bloqueado";

    if (
      turnos.some(t => {
        if (!t.fechaHora) return false;

        const fechaTurno = t.fechaHora.toDate
          ? t.fechaHora.toDate()
          : new Date(t.fechaHora.seconds * 1000);

        return formatearFecha(fechaTurno) === dateStr;
      })
      
    ) return "dia-con-turnos";

    return "";
  }}
/>

{/* Turnos del día */}
{fechaSeleccionada && (
  <div style={{ marginTop: "15px", width: "100%", maxWidth: "400px" }}>
   <div
  style={{
    textAlign: "center",
    background: "white",
    padding: "12px 18px",
    borderRadius: "10px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
    fontWeight: 600,
    fontSize: "20px"
    
  }}
>
  📅 {fechaSeleccionada.toLocaleDateString("es-AR", {
    weekday: "long",
    day: "numeric",
    month: "long"
  })}
</div>

    {Array.from({ length: 13 }, (_, i) => i + 8).map(hora => {
      const dateStr = fechaSeleccionada.toISOString().split("T")[0];

      // Buscar turno si existe
      const turno = turnosDia.find(t => {
        const fechaTurno = t.fechaHora.toDate
          ? t.fechaHora.toDate()
          : new Date(t.fechaHora.seconds * 1000);
        return fechaTurno.getHours() === hora;
      });

     

      const estadosOcupados = ["confirmado", "pendiente"];

      const tieneTurno = turno && estadosOcupados.includes(turno.estado);
      const bloqueado = horariosBloqueados[dateStr]?.includes(Number(hora));

      return (
        <div
        key={hora}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
      
          padding: "25px 20px",
          borderRadius: "10px",
      
          background: bloqueado
            ? "#fee2e2"
            : turno
            ? "#e0f2fe"
            : "#ecfdf5",
      
          border: "1px solid rgba(0,0,0,0.05)",
      
          boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
      
          transition: "0.2s",
        }}
      >
         <span style={{ fontWeight: 600, fontSize: "20px" }}>
  {hora}:00
</span>

<span style={{ fontSize: "18px", fontWeight: 600,     padding: "8px 12px",
}}>
  {bloqueado
    ? "Bloqueado"
    : turno
    ? `${pacientes?.[turno.patientId]?.nombre || ""} ${pacientes?.[turno.patientId]?.apellido || ""}`
    : "Libre"}
</span>

<span
  style={{
    fontSize: "12px",
    fontWeight: 600,
    padding: "4px 8px",
    borderRadius: "999px",

    background:
      turno?.estado === "confirmado"
        ? "#dcfce7"
        : turno?.estado === "pendiente"
        ? "#fef9c3"
        : turno?.estado === "cancelado"
        ? "#fee2e2"
        : "transparent",

    color:
      turno?.estado === "confirmado"
        ? "#166534"
        : turno?.estado === "pendiente"
        ? "#854d0e"
        : turno?.estado === "cancelado"
        ? "#991b1b"
        : "#444",

    minWidth: "70px",
    textAlign: "center"
  }}
>
  {turno?.estado || ""}
</span>

<button
  onClick={() => {
    if (tieneTurno) return; // 🚫 bloquea acción
    toggleBloquearHorario(fechaSeleccionada, hora);
  }}
  disabled={tieneTurno}
  style={{
    padding: "6px 10px",
    borderRadius: "999px",
    border: "none",
    cursor: tieneTurno ? "not-allowed" : "pointer",

    fontSize: "14px",
    fontWeight: 600,

    background: tieneTurno
      ? "#94a3b8" // gris si ocupado
      : bloqueado
      ? "#16a34a"
      : "#ef4444",

    color: "white",
    opacity: tieneTurno ? 0.6 : 1
  }}
>
  {tieneTurno ? "O" : bloqueado ? "✓" : "✕"}
</button>
        </div>
      );
    })}

    {/* Botón para bloquear o desbloquear día completo */}
    <button
  onClick={() => toggleBloquearDia(fechaSeleccionada)}
  style={{
    marginTop: "20px",
    padding: "10px 16px",

    borderRadius: "999px",
    border: "none",

    cursor: "pointer",

    fontWeight: 600,
    fontSize: "14px",

    background: diasBloqueados.includes(
      fechaSeleccionada.toISOString().split("T")[0]
    )
      ? "#16a34a"
      : "#ef4444",

    color: "white",

    boxShadow: "0 6px 14px rgba(0,0,0,0.15)",

    transition: "0.2s"
  }}
>
  {diasBloqueados.includes(
    fechaSeleccionada.toISOString().split("T")[0]
  )
    ? "Día habilitado"
    : "Bloquear día completo"}
</button>
  </div>
)}
      </div>
  );
}